import * as RadixTabs from '@radix-ui/react-tabs';

import { Close24 } from '@ingrid/iconography/react';
import { IconButton, styled } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

const Root = styled(RadixTabs.Root, {
  '&:focus-visible': {
    outline: 'none',
  },
});

const List = styled(RadixTabs.List, {
  display: 'flex',
});

const Trigger = styled(RadixTabs.Trigger, {
  background: 'transparent',
  fontFamily: '$universal',
  padding: '9px 16px',
  lineHeight: '18px',
  cursor: 'pointer',
  fontSize: '12px',
  border: 0,

  '&:focus-visible': {
    outline: '2px solid $purple',
  },

  '&[aria-selected="true"]': {
    background: 'white',
    fontWeight: 'bold',
  },

  '&:disabled': {
    cursor: 'not-allowed',
    opacity: '.6',
  },

  variants: {
    mode: {
      dark: {
        '&[aria-selected="true"]': {
          background: 'var(--grey-18)',
        },
      },
    },
  },
});

const Content = styled(RadixTabs.Content, {
  height: 'calc(100% - 68px)',
  background: 'white',
  padding: '16px',

  variants: {
    mode: {
      dark: {
        background: 'var(--grey-18)',
      },
    },
  },

  '&:focus-visible': {
    outline: 'none',
  },
});

function Close({ onClick }: { onClick?: () => void }) {
  const { t } = useTranslation();

  return (
    <IconButton
      style={{ marginLeft: 'auto', marginTop: '1px' }}
      aria-label={t('common.close')}
      variant="quaternary"
      onClick={onClick}
      size="sm"
    >
      <Close24 />
    </IconButton>
  );
}

export const StepTabs = {
  Root,
  Trigger,
  Content,
  Close,
  List,
};
